import { Tooltip, Grid } from "antd";

const HToolTip = ({ title, children }) => {
  const { lg } = Grid.useBreakpoint();
  if (lg) {
    return <Tooltip title={title}>{children}</Tooltip>;
  }
  return children;
};

export default HToolTip;
